import React, { useState, useEffect } from 'react';
import { CheckCircle, MessageCircle, Mail } from 'lucide-react';


export default function OrderConfirmationPage({ setPage }) {
  const [companyName, setCompanyName] = useState('Your Company');
  const poid = localStorage.getItem('poid') || '0';
  const vcode = localStorage.getItem('vcode') || '';
  const vname = localStorage.getItem('vname') || 'Vendor';
  const address = localStorage.getItem('cusAddress') || '';
  const deliveryDate = localStorage.getItem('deliveryDate') || new Date().toLocaleDateString();
  const paymode = localStorage.getItem('paymode') || 'UPI';
  const amount = localStorage.getItem('amountPaid') || '0.00';
  const ref = localStorage.getItem('referenceNo') || 'N/A';
  const email = localStorage.getItem('mail') || '';

  const cartData = JSON.parse(localStorage.getItem('orderCart') || '[]');
  const total = parseFloat(localStorage.getItem('orderTotal') || 0);
  const netTotal = (total).toFixed(2);

  useEffect(() => {
    fetch('/config.json')
      .then((res) => res.json())
      .then((data) => {
        if (data.CompanyName) {
          setCompanyName(data.CompanyName);
        }
      })
      .catch((err) => {
        console.error('Failed to load config.json:', err);
      });
  }, []);

  const itemLines = cartData.map(item =>
    `${item.name} x${item.quantity} - ₹${(item.price * item.quantity).toFixed(2)}`
  ).join('\n');

  const message = `
ORDER CONFIRMATION
Dear ${vname},
Thank you for your purchase from ${companyName}
Address: ${address}

Order ID: #${poid}
Order Date: ${deliveryDate}

Items:
${itemLines}

Subtotal: ₹${total.toFixed(2)}
Net Total: ₹${netTotal}

Payment Mode: ${paymode}
Amount Paid: ₹${amount}
Reference No: ${ref}
`.trim();

  const handleWhatsAppShare = () => {
    const whatsappURL = `https://wa.me/${vcode}?text=${encodeURIComponent(message)}`;
    window.open(whatsappURL, '_blank');
  };

  const handleSendEmail = async () => {
  if (!email) {
    alert('Email address not found in localStorage');
    return;
  }

  try {
    const res = await fetch(`http://kngservice.revampapps.com/SendOrderEmail?Mail=${encodeURIComponent(email)}`);
    const json = await res.json();

    const result = json?.SendOrderEmailJs?.Table?.[0];

    if (result?.Status === 'Success') {
      alert('Order confirmation email sent successfully.');
    } else {
      alert('Failed to send order email.');
    }
  } catch (err) {
    console.error('Email error:', err);
    alert('An error occurred while sending email.');
  }
};

  return (
    <div className="container mx-auto max-w-2xl text-center py-12 px-4">
      <div className="bg-white p-10 rounded-2xl shadow-xl inline-block">
        <CheckCircle className="text-green-500 h-20 w-20 mx-auto mb-4" />
        <h2 className="text-3xl font-bold text-gray-900 mb-2">Thank You!</h2>
        <p className="text-gray-600 mb-8">Your order has been placed successfully.</p>

        <div className="flex flex-col gap-4 sm:flex-row justify-center">
          <button
            onClick={() => setPage('products')}
            className="bg-teal-600 text-white font-bold py-3 px-6 rounded-lg hover:bg-teal-700 transition shadow-md"
          >
            Continue Shopping
          </button>

          <button
            onClick={handleWhatsAppShare}
            className="bg-green-500 text-white font-bold py-3 px-6 rounded-lg hover:bg-green-600 transition shadow-md flex items-center justify-center gap-2"
          >
            <MessageCircle size={18} /> Share via WhatsApp
          </button>

          <button
            onClick={handleSendEmail}
            className="bg-blue-500 text-white font-bold py-3 px-6 rounded-lg hover:bg-blue-600 transition shadow-md flex items-center justify-center gap-2"
          >
            <Mail size={18} /> Send via Email
          </button>
        </div>
      </div>
    </div>
  );
}
